export function initVideo(){

	document.querySelectorAll('.video').forEach(wrapper => {

		const player = wrapper.querySelector('.video__player');
		const type   = wrapper.dataset.videoType;

		function resetVideo(target){

			const video = target.querySelector('video');
			const player = target.querySelector('.video__player');

			target.classList.remove('_playing');
			target.classList.remove('_coverout');

			if(video){
				video.pause();
				video.currentTime = 0;
			}

			if(player){
				player.innerHTML = '';
			}

		}

		function stopOtherVideos(){

			document.querySelectorAll('.video._playing').forEach(other => {

				if(other !== wrapper){
					resetVideo(other);
				}

			});

		}

		function playVideo(){

			stopOtherVideos();

			wrapper.classList.add('_coverout');

			// MP4
			if(type === 'file'){

				const src  = wrapper.dataset.videoSrc;
				const mime = wrapper.dataset.videoMime;

				const video = document.createElement('video');

				video.playsInline = true;
				video.autoplay = true;
				video.preload = 'metadata';

				const source = document.createElement('source');

				source.src  = src;
				source.type = mime;

				video.appendChild(source);

				player.appendChild(video);

				video.addEventListener('ended', () => resetVideo(wrapper));

			}

			// YOUTUBE
			if(type === 'youtube'){

				let url = wrapper.dataset.youtube;

				url = url.replace('watch?v=','embed/');

				const iframe = document.createElement('iframe');

				iframe.src =
					url +
					'?autoplay=1&rel=0&controls=0&modestbranding=1';

				iframe.allow =
					'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';

				iframe.frameBorder = 0;

				player.appendChild(iframe);

			}

			wrapper.classList.add('_playing');

		}

		wrapper.addEventListener('click', () => {

			if(wrapper.classList.contains('_playing')){
				resetVideo(wrapper);
			}else{
				playVideo();
			}

		});

	});

}